








































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import PolygonDrawer from "@/components/wrappedGoogleMaps/PolygonDrawer.vue";
import Polygon from "ol/geom/Polygon";
import i18n from "@/i18n";
import {
  wrapGeometryObject,
  geometryFromGeojsonText,
  featuresFromGeojsonText,
  geoJSONFormatter,
} from "@/helpers/geojson";
import { isPolygon } from "@/helpers/geometry";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import * as notificationService from "@/services/notification/index";
import { RuralInfo } from "@/api/car/types";
import { LocationPayload } from "@/components/wrappedGoogleMaps/types";

@Component({
  name: "FarmDrawingModal",
  components: {
    Drawer: PolygonDrawer,
  },
})
export default class FarmDrawingModal extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly open!: boolean;

  @Prop({ type: Boolean, default: false }) private readonly disabled!: boolean;

  @Prop({ type: Object, default: null }) private carResponse!: RuralInfo;

  @Prop(Object) private startLocation!: LocationPayload | undefined; 

  private tabActive: number | null = null;

  private text: string = "";

  private message = { geojson: "" };

  private polygon: Geometry | null = null;

  private copyGeoJson: boolean = false;

  private textPlaceholder: string =
    "{\r\n   'type' : 'Polygon',\r\n   'coordinates' : \r\n [\r\n   [\r\n      [-46.65930122645873, -23.56130797255635]," +
    "\r\n      [-46.65889353068847, -23.56161283872262],\r\n      [-46.65857166560668, -23.56127846934141]," +
    "\r\n      [-46.65894717486876, -23.56102277453456],\r\n      [-46.65930122645873, -23.56130797255635]\r\n   ]\r\n ]\r\n}";

  private mounted() {
    this.text = "";
    this.setTabActive(0);
  }

  private isActive(clickedItem: number) {
    return this.tabActive === clickedItem;
  }

  private setTabActive(clickedItem: number) {
    this.tabActive = clickedItem;
    return this.tabActive;
  }

  private finishDrawing(geojsonAsText: string) {
    this.$emit("ondrawcomplete", geometryFromGeojsonText(geojsonAsText));
  }

  @Emit("oncancel")
  private cancelDrawing() {
    this.text = "";
    this.polygon = null;
    this.copyGeoJson = false;
  }

  @Watch("text", { immediate: true })
  private verifyText(text: string) {
    this.text = text;
    this.validateGeoJson(text);
  }

  @Watch("carResponse", { immediate: true })
  private showFarmINFO() {
    if (!!this.carResponse) {
      this.renderCarPoints(this.carResponse);
    }
  }

  private validateGeoJson(text: string) {
    this.polygon = null;
    let geometry: Geometry | null = null;
    try {
      const feature = featuresFromGeojsonText(text);
      if (feature.length === 1) {
        geometry = feature[0].getGeometry();
      } else {
        this.message.geojson = i18n
          .t("geojson-validation.only-one-polygon")
          .toString();
        return;
      }
    } catch (err) {
      try {
        geometry = geometryFromGeojsonText(text);
      } catch (err) {
        geometry = null;
      }
    }

    if (!!geometry) {
      if (isPolygon(geometry)) {
        this.polygon = geometry;
        this.message.geojson = "";
      } else {
        this.message.geojson = i18n
          .t("geojson-validation.only-polygon")
          .toString();
      }
    } else {
      this.message.geojson = i18n
        .t("geojson-validation.invalid-geometry")
        .toString();
      this.polygon = null;
    }
  }

  private sendText() {
    this.$emit("ondrawcomplete", this.polygon);
  }

  private clearDrawing() {
    (this.$refs.mapChild as any).clearDrawing();
    this.text = "";
    this.polygon = null;
    this.copyGeoJson = false;
    (this.$refs.mapChild as any).removeCarsNear();
  }

  private clearFields() {
    this.text = "";
    this.polygon = null;
  }

  private get disabledConfirmation() {
    return this.polygon == null || this.disabled;
  }

  private showCopyPastOptions() {
    this.copyGeoJson = !this.copyGeoJson;
  }

  private renderUploadedMap(farmMap: any) {
    let geometry: Geometry | null = null;
    this.validateEmptyFeature(farmMap);
    const feature = featuresFromGeojsonText(farmMap);
    geometry = feature[0].getGeometry();
    this.polygon = geometry;
    this.sendText();
  }

  private validateEmptyFeature(farmMap: any) {
    if (featuresFromGeojsonText(farmMap).length == 0) {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.map-file-without-features") as string
      );
      this.$emit("cancelCreation");
      return;
    }
  }

  @Emit('foundRuralInfo')
  private foundCarByPoint(ruralInfo: RuralInfo) {}

  private renderCarPoints(ruralInfo: RuralInfo) {
    this.validateEmptyFeature(ruralInfo.geom);
    this.polygon = geometryFromGeojsonText(JSON.stringify(ruralInfo.geom));
    this.finishDrawing(JSON.stringify(ruralInfo.geom));
  }

  private toggleSearchCarModal() {
    this.$emit("showSearchCarModal");
  }
}
